// This file should only contain action type constants.

export const SET_FEATURES = 'SET_FEATURES';
export const VCDA_ERROR = 'VCDA_ERROR';
